import React from 'react';
import { Search, X } from 'lucide-react';

/**
 * CommandCenterSearch — controlled search input with clear button and
 * a live result count. Matches the Home page's white pill-search style.
 */
export default function CommandCenterSearch({ value, onChange, resultCount, isFiltering }) {
  return (
    <div className="cc-search-wrap" role="search">
      <Search size={18} className="cc-search-icon" aria-hidden="true" />
      <label htmlFor="cc-search-input" className="sr-only" style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)' }}>
        Search AskStewie tools
      </label>
      <input
        id="cc-search-input"
        type="search"
        className="cc-search-input"
        placeholder="Search grievances, discipline, safety, documents…"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Search AskStewie tools"
        data-testid="cc-search-input"
      />
      {value && (
        <button
          type="button"
          className="cc-search-clear"
          onClick={() => onChange('')}
          aria-label="Clear search"
          data-testid="cc-search-clear"
        >
          <X size={14} />
        </button>
      )}
      {isFiltering && (
        <span className="cc-search-count" data-testid="cc-search-count" aria-live="polite">
          {resultCount === 1 ? '1 tool' : `${resultCount} tools`}
        </span>
      )}
    </div>
  );
}
